import React, { useCallback } from 'react';
import { services } from '../mock';
import { Shield, FileText, Lightbulb, Building, ChevronLeft, ChevronRight } from 'lucide-react';
import useEmblaCarousel from 'embla-carousel-react';
import Autoplay from 'embla-carousel-autoplay';

const iconComponents = { Shield, FileText, Lightbulb, Building };

const ServicesSection = () => {
  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true, align: 'start', duration: 45 }, [Autoplay({ delay: 4000, stopOnInteraction: false })]);
  const scrollPrev = useCallback(() => { if (emblaApi) emblaApi.scrollPrev(); }, [emblaApi]);
  const scrollNext = useCallback(() => { if (emblaApi) emblaApi.scrollNext(); }, [emblaApi]);

  return (
    <section className="py-24 bg-[#F9F8F6]" data-testid="home-services-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-16">
          <p className="eyebrow mb-4">Practice Areas</p>
          <h2 className="font-display text-4xl md:text-5xl font-bold text-[#111C16] tracking-tighter mb-4">Comprehensive IP services</h2>
          <p className="font-body text-[#4A5D53] max-w-xl mx-auto text-sm">Full-spectrum legal protection for every dimension of your intellectual property.</p>
        </div>
        {/* Desktop: Bento Grid */}
        <div className="hidden md:grid md:grid-cols-12 gap-6">
          {services.map((service, i) => {
            const Icon = iconComponents[service.icon];
            const span = i === 0 ? 'md:col-span-8' : i === 1 ? 'md:col-span-4' : i === 2 ? 'md:col-span-4' : 'md:col-span-8';
            return (
              <div key={service.id} className={`${span} group bg-white rounded-3xl p-8 border border-[#D5D1C8] hover-lift hover-gold-border`} data-testid={`service-card-${service.id}`}>
                <div className="w-12 h-12 rounded-2xl bg-[#1A3628] flex items-center justify-center mb-6 group-hover:bg-[#C85A40] transition-colors duration-300">
                  <Icon className="h-6 w-6 text-white" strokeWidth={1.5} />
                </div>
                <h3 className="font-display text-xl font-medium text-[#111C16] mb-3">{service.title}</h3>
                <p className="font-body text-sm text-[#4A5D53] leading-relaxed">{service.description}</p>
              </div>
            );
          })}
        </div>
        {/* Mobile Slider */}
        <div className="md:hidden relative">
          <button onClick={scrollPrev} className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-1 z-10 bg-white shadow-md rounded-full p-2 border border-[#D5D1C8]"><ChevronLeft className="w-5 h-5 text-[#1A3628]" strokeWidth={1.5} /></button>
          <button onClick={scrollNext} className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-1 z-10 bg-white shadow-md rounded-full p-2 border border-[#D5D1C8]"><ChevronRight className="w-5 h-5 text-[#1A3628]" strokeWidth={1.5} /></button>
          <div className="overflow-hidden px-2" ref={emblaRef}>
            <div className="flex gap-4">
              {services.map((service) => {
                const Icon = iconComponents[service.icon];
                return (
                  <div key={service.id} className="flex-[0_0_85%] min-w-0">
                    <div className="bg-white rounded-3xl p-6 border border-[#D5D1C8] h-full">
                      <div className="w-10 h-10 rounded-xl bg-[#1A3628] flex items-center justify-center mb-4"><Icon className="h-5 w-5 text-white" strokeWidth={1.5} /></div>
                      <h3 className="font-display text-lg font-medium text-[#111C16] mb-2">{service.title}</h3>
                      <p className="font-body text-sm text-[#4A5D53] leading-relaxed">{service.description}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
